/**
 * @generated SignedSource<<a560aa0b325db6a8ed747d8b6f96edb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedMoreWaysToBrowse_internalBuyLinks$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SharedMobileLinksBlock_links" | "SharedRespLinksBlock_links">;
  readonly " $fragmentType": "BuySharedMoreWaysToBrowse_internalBuyLinks";
}>;
export type BuySharedMoreWaysToBrowse_internalBuyLinks$key = ReadonlyArray<{
  readonly " $data"?: BuySharedMoreWaysToBrowse_internalBuyLinks$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedMoreWaysToBrowse_internalBuyLinks">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "BuySharedMoreWaysToBrowse_internalBuyLinks",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedMobileLinksBlock_links"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_links"
    }
  ],
  "type": "InternalBuyLinkType",
  "abstractKey": null
};

(node as any).hash = "3f7afd6164f91ea778e33082d2c8d10b";

export default node;
